import { Controller } from "@hotwired/stimulus"

// A link copied to paste somewhere else, such as a team invite's link for a text message. The button says so for a
// moment after.
export default class extends Controller {
  static values = { text: String }

  async copy() {
    const button = this.element
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch {
      return
    }
    const was = button.textContent
    button.textContent = "Copied"
    setTimeout(() => (button.textContent = was), 1600)
  }
}
